"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.css = exports.responsive = exports.get = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _responsiveHelpers = require("responsive-helpers");

/**
 * TODO: VERY IMPORTANT NOTES
 *
 * BEWARE!!! Fixing this file will take you longer than you think it will.
 *
 *
 * 1. This file is copied from styled-system which is not maintained and theme-ui has newest version
 * 2. Modifications in this file are:
 * a) font -> it's just custom variant actually, we could do PR for theme-ui for this.
 * b) linear spacings -> we should do them in array / object form with linearity done as "step functions". Arithmetic will be trivial to implement and we could add this as a PR to theme-ui.
 * c) make it possible to use [0, 0, "gridGap"] by using recursion. We could make it as a PR too.
 *
 * New version of theme-ui is constantly updated, for example it now has nested array styles, one thing that was missing here.
 *
 * Bugs in current version: there's only one level of recursion and no nested styles so:
 * mt: "gridGap"
 *
 * ... will work if this is on the top level:
 * 1. In first iteration it will be transformed into array.
 * 2. In second iteration array will be decoupled into values.
 *
 * Not sure if it work deeper.
 *
 * To sum up, we should sync with theme-ui and build PR for them.
 *
 */
// based on https://github.com/developit/dlv
var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split(".") : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};

exports.get = get;
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + "em";
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
var multiples = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
};
var scales = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== "number" || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === "string") return "-" + n;
  return n * -1;
};

var transforms = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function (acc, curr) {
  return (0, _objectSpread3["default"])({}, acc, (0, _defineProperty2["default"])({}, curr, positiveOrNegative));
}, {});

function isStylesObject(obj) {
  if (typeof obj !== "object") {
    return false;
  }

  if (obj.__isLinear) {
    return false;
  }

  if (typeof obj._ !== "undefined") {
    return false;
  }

  return true;
}

var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get(theme, "breakpoints", defaultBreakpoints);
    var mediaQueries = [null].concat((0, _toConsumableArray2["default"])(breakpoints.map(function (n) {
      return "@media screen and (min-width: ".concat(n, ")");
    }))); // MODIFICATION: let's add all media in a good order so that this order is kept later

    for (var k = 1; k < mediaQueries.length; k++) {
      next[mediaQueries[k]] = null;
    } // console.log('next', next);
    // mediaQueries.forEach(query => {
    //     if (query) {
    //         next[query] = {};
    //     }
    // });


    for (var key in styles) {
      var value = typeof styles[key] === "function" ? styles[key](theme) : styles[key]; // here we could get value from scales and transform it.

      if (value == null) continue;
      /** MODIFICATION 3, linear spacings **/

      if (typeof value === "object" && value.__isLinear) {
        var _css = (0, _responsiveHelpers.rslin)(theme.space[value.from] || value.from, theme.space[value.to] || value.to, value.isInf).cssObject(key);

        for (var media in _css) {
          next[media] = next[media] || {};
          next[media][key] = _css[media][key];
        }

        continue;
      }
      /** MODIFICATION 2, check if this is responsive object **/


      if (typeof value === "object" && typeof value._ !== "undefined") {
        for (var breakpoint in value) {
          if (breakpoint !== "_" && !breakpoints[breakpoint]) {
            throw new Error("Wrong breakpoint name in your rs styles: \"".concat(breakpoint, "\""));
          }

          var _media = "@media screen and (min-width: ".concat(breakpoints[breakpoint], ")");

          if (breakpoint === "_") {
            _media = undefined;
          }

          if (!_media) {
            next[key] = value[breakpoint];
            continue;
          }

          next[_media] = next[_media] || {};
          next[_media][key] = value[breakpoint];
        }

        continue;
      }

      if (!(0, _isArray["default"])(value)) {
        next[key] = value;
        /** MODIFICATION: it's required for cssSingle(cssSingle(...)) recursion to work. We don't want old media queries to override new ones. **/
        // if (isStylesObject(next[key])) {
        //     next[key] = {
        //         ...next[key],
        //         ...value
        //     };
        // } else {
        //     next[key] = value;
        // }

        continue;
      }
      /**
       * IF ARRAY
       */


      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var _media2 = mediaQueries[i];
        if (value[i] == null) continue;

        if (!_media2) {
          next[key] = value[i];
          continue;
        }

        next[_media2] = next[_media2] || {};
        next[_media2][key] = value[i];
      }
    } // MODIFICATION: let's clean up empty media queries


    for (var _key in next) {
      if (next[_key] === null) {
        delete next[_key];
      }
    }

    return next;
  };
};

exports.responsive = responsive;

function getValue(val, key, theme) {
  var prop = get(aliases, key, key);
  var scaleName = get(scales, prop);
  var scale = get(theme, scaleName, get(theme, prop, {}));
  var transform = get(transforms, prop, get);
  var value = transform(scale, val, val); // RESPONSIVE SIZE

  if (typeof value === "object" && value !== null && value.__isLinear) {
    var _css2 = (0, _responsiveHelpers.rslin)(theme.space[value.from] || value.from, theme.space[value.to] || value.to, value.isInf).cssObject("xxx");

    var css_ = (0, _values["default"])(_css2);
    var array = [];

    for (var i = 0; i < theme.breakpoints.length + 1; i++) {
      array[i] = null;

      if (i === 0) {
        array[i] = css_[0].xxx;
      } else if (i === theme.breakpoints.length) {
        array[i] = css_[2].xxx;
      } else {
        array[i] = css_[1].xxx;
      }
    }

    return array;
  }

  if (!(0, _isArray["default"])(value)) {
    // non-array values can easily pass
    return value;
  }

  var lastBreakpointArray; // null-padding of array shorter than num of breakpoints + 1 (this is required because [0, null, "containerMargin"] should actually affect 3th and 4th index

  for (var _i = value.length; _i < theme.breakpoints.length + 1; _i++) {
    value[_i] = null;
  }

  for (var _i2 = 0; _i2 < value.length; _i2++) {
    var breakpointVal = getValue(value[_i2], key, theme, _i2);

    if (breakpointVal === null || breakpointVal === undefined) {
      if (lastBreakpointArray) {
        value[_i2] = lastBreakpointArray[_i2];
      } else {
        value[_i2] = null;
      }
    } else if ((0, _isArray["default"])(breakpointVal)) {
      value[_i2] = breakpointVal[_i2];
      lastBreakpointArray = breakpointVal;
    } else {
      lastBreakpointArray = null;
      value[_i2] = breakpointVal;
    }
  }

  return value;
}

var css = function css(args) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = (0, _objectSpread3["default"])({}, defaultTheme, props.theme || props);
    var result = {};
    var obj = (0, _objectSpread3["default"])({}, typeof args === "function" ? args(theme) : args); // Pre-iteration flattening arrays with values from theme

    for (var key in obj) {
      obj[key] = getValue(obj[key], key, theme);
    }

    var styles = responsive(obj)(theme);

    for (var _key2 in styles) {
      var x = styles[_key2];
      var val = typeof x === "function" ? x(theme) : x;

      if (_key2 === "variant") {
        var variant = css(get(theme, val))(theme);
        result = (0, _objectSpread3["default"])({}, result, variant);
        continue;
      }
      /** MODIFICATION 1, special value font **/


      if (_key2 === "font") {
        var _variant = css(get(theme, "typography." + val))(theme);

        result = (0, _objectSpread3["default"])({}, result, _variant);
        continue;
      }

      if (val && typeof val === "object") {
        result[_key2] = css(val)(theme); // TODO: bug, second iteration overrides first one (or other way round), media queries are not merged in a smart way

        continue;
      }

      var prop = get(aliases, _key2, _key2);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

exports.css = css;
var _default = css;
exports["default"] = _default;